import { theme } from "@huub-web/ui/theme/css/theme.css";
import { recipe } from "@vanilla-extract/recipes";
import { responsive } from "@huub-web/ui/utils/responsive";
import { rem } from "@huub-web/utils/css/rem";

const EDGE_HEIGHT = 56;

export const sectionStyle = recipe({
  base: {
    // overflowX: "hidden",
    width: "100%",
    ...responsive({
      base: {
        padding: `${theme.spacings.m} 0`,
        gap: theme.spacings.m,
      },
      s: {
        padding: `${theme.spacings.l} 0`,
        gap: theme.spacings.l,
      },
      m: {
        padding: `${theme.spacings.xl} 0`,
        gap: theme.spacings.xl,
      },
    }),
  },
  variants: {
    overflowVisible: {
      true: {
        overflow: "visible",
      },
    },
    variant: {
      default: {},
      shade: {
        backgroundColor: theme.colors.backgroundShade,
      },
      tint: {
        backgroundColor: theme.colors.backgroundTint,
      },
      tintMarketing: {
        backgroundColor: theme.colors.backgroundTintMarketing,
      },
    },
    edge: {
      background: {
        ":after": {
          content: '""',
          backgroundColor: theme.colors.background,
          height: rem(EDGE_HEIGHT),
          width: "100%",
          position: "absolute",
          left: 0,
        },
      },
      shade: {
        ":after": {
          content: '""',
          backgroundColor: theme.colors.backgroundShade,
          height: rem(EDGE_HEIGHT),
          width: "100%",
          position: "absolute",
          left: 0,
        },
      },
      tint: {
        ":after": {
          content: '""',
          backgroundColor: theme.colors.backgroundTint,
          height: rem(EDGE_HEIGHT),
          width: "100%",
          position: "absolute",
          left: 0,
        },
      },
      tintMarketing: {
        ":after": {
          content: '""',
          backgroundColor: theme.colors.backgroundTintMarketing,
          height: rem(EDGE_HEIGHT),
          width: "100%",
          position: "absolute",
          left: 0,
        },
      },
      none: {
        paddingBottom: `${rem(2)} !important`,
      },
    },
    edgePosition: {
      top: {
        paddingTop: `${rem(2)} !important`,
        ":after": {
          top: 0,
        },
      },
      bottom: {
        paddingBottom: `${rem(2)} !important`,
        ":after": {
          bottom: 0,
        },
      },
    },
  },
  defaultVariants: {},
});
